import React from "react";
import { Linkedin, CalendarClock } from "lucide-react";
import { ConduitMark } from "./Logos";
import { LINKEDIN_PERSONAL, LINKEDIN_COMPANY, CALENDLY_URL } from "../mock";

export default function Footer() {
  return (
    <footer style={{ borderTop: "1px solid var(--line)", background: "var(--paper-2)" }}>
      <div className="container-x" style={{ padding: "48px 24px 40px" }}>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <ConduitMark size={24} color="var(--ink)" />
              <span style={{ fontFamily: "'Newsreader', Georgia, serif", fontWeight: 600, fontSize: 26, letterSpacing: "-0.01em" }}>Conduit</span>
            </div>
            <p className="serif" style={{ fontSize: 22, marginTop: 12, color: "var(--ink-soft)", maxWidth: 400 }}>
              Belkins-grade meetings, at 40% of the price.
            </p>
            <div className="flex flex-wrap gap-2.5" style={{ marginTop: 18 }}>
              <a href={LINKEDIN_PERSONAL} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 13 }}>
                <Linkedin size={15} /> Vinay
              </a>
              <a href={LINKEDIN_COMPANY} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 13 }}>
                <Linkedin size={15} /> Company
              </a>
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 13 }}>
                <CalendarClock size={15} /> Book a call
              </a>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-10 gap-y-3" style={{ fontSize: 14 }}>
            {[
              ["Reply desk", "#reply"],
              ["Markets", "#markets"],
              ["How it works", "#how"],
              ["Demo", "#demo"],
              ["Pricing", "#pricing"],
              ["About", "#about"],
              ["Apply", "#apply"],
            ].map(([l, h]) => (
              <a key={h} href={h} style={{ color: "var(--ink-soft)", transition: "color 0.2s ease" }}
                 onMouseEnter={(e) => (e.currentTarget.style.color = "var(--ink)")}
                 onMouseLeave={(e) => (e.currentTarget.style.color = "var(--ink-soft)")}>
                {l}
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" style={{ marginTop: 40, paddingTop: 22, borderTop: "1px solid var(--line)", fontSize: 12.5, color: "var(--ink-faint)" }}>
          <span>Outbound for market entry · UK, Europe and the US</span>
          <span>Billing: monthly, in advance · Referral partners earn 10 to 15%</span>
        </div>
      </div>
    </footer>
  );
}
